<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div :class="checkWidth() + ' ' + 'container'">
        <CRow>
          <CCol col="12">
            <div
              class="background-image"
              v-bind:style="`background-image:url(https://mdl.mfu.ac.th/${message.media[0].url})`"
            >
              <div v-if="show">
                <div class="position">
                  <div class="card">
                    <div class="block">
                      <h1>MISSION COMPLETE!</h1>
                      <div
                        class="button button-next"
                        @click="commitUserProgress"
                      >
                        <div col="12">
                          <div style="font-size: 18px">NEXT</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="image_size" v-else>
                <div class="image_person">
                  <img
                    :src="'https://mdl.mfu.ac.th' + message.media[1].url"
                    class="image"
                    style="object-fit: contain"
                  />
                </div>
                <div class="image_person">
                  <img
                    :src="'https://mdl.mfu.ac.th' + message.media[2].url"
                    class="image"
                    style="object-fit: contain"
                  />
                </div>
                <div class="card_message">
                  <CardMessage
                    :index="index_display_message"
                    :message="message.message"
                    :showModal="true"
                    :profile_image="message.media[3].url"
                    :lang="language"
                    @returnIndex="next"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardMessage from '@/components/elements/Card/CardMessage';
import LoadingMDL from '@/components/loading/LoadingMDL';
import '../../../assets/scss/chinessStyle2.scss';

export default {
  name: 'CMD01',
  components: {
    CardMessage,
    LoadingMDL,
  },
  props: {},
  data() {
    return {
      message: [],
      language: '',
      loading: true,
      navigate: '',
      content: [],
      index_display_message: 0,
      CheckWidth: window.innerWidth.toString(),
      condition: [],
      startTime: '',
      criteria_id: '',
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      show: false,
      v3Data: null,
      nextPath: null,
    };
  },
  methods: {
    onLoadData() {
      this.loading = true;
      this.language = this.$store.getters['language/getLanguage'];
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    next: function (index) {
      if (index == this.content.length - 1) {
        var str = this.navigate;

        if (str[0] == 'LS01') {
          this.loading = true;

          //use commit  anyway
          this.commitUserProgress(str);
          this.show = true;
        } else {
          this.loading = true;

          //use commit  anyway
          this.commitUserProgress(str);
        }
      } else {
        this.index_display_message = index + 1;
        this.message = this.content[index + 1];
      }
    },

    commitUserProgress: function (path) {
      // const next = this.action.next.action;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
        this.loading = false;
      }
    },
    checkWidth() {
      if (this.CheckWidth > 500) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 500) {
        return 'container-chinese-card-mobile';
      }
    },
    resetLocalState() {
      this.index_display_message = 0;
      this.message = [];
    },
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.item;
      this.message = template.content.item[0];
      this.navigate = template.navigate.next.action;

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.loading = true;

      this.resetLocalState();
      this.onLoadData();
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'CMD01 saveContent Call');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },

    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  width: 700px;
  height: 300px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.block {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.button {
  width: 145px;
  height: 43px;
  margin-bottom: 0;
  background-color: #1d5bd7;
  color: white;
  font-size: 12px;
  border-radius: 8px !important;
  cursor: pointer;
  margin-top: 10%;
}
.image_size {
  width: 100%;
  height: 70vh;
  display: flex;
}
.container {
  min-width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  z-index: 1;
  overflow-x: hidden;
  position: relative;
}
div.min-vh-100 {
  z-index: -99;
}
.background-image {
  width: 100%;
  // justify-content: center;
  height: 100vh;
  padding: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image {
  height: 100%;
  width: 50%;
}
.image_person {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.card_message {
  position: absolute;
  display: flex;
  margin: 0 auto;
  left: 0;
  right: 0;
  justify-content: center;
  width: 80%;
  z-index: 1;
  bottom: 10%;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .image {
    height: 100%;
    width: 50%;
    object-fit: contain;
  }
  .image_person {
    margin-top: 20%;
    display: flex;
    justify-content: space-between;
    height: 50%;
    align-items: center;
  }
  .card_message {
    width: 80%;
    height: 45%;
  }
  .body_message {
    font-size: 24px;
  }
  .card {
    width: 290px;
    height: 200px;
  }
  h1 {
    font-size: 27px;
  }
}
// resolution ipad
@media only screen and (min-width: 600px) and (max-width: 1023px) {
  .image_person {
    margin-top: 5%;
    display: flex;
    justify-content: space-between;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1365px) and (min-height: 1024px) and (max-height: 1367px) {
  .image_person {
    height: 100%;
  }
  .image {
    height: 90%;
    width: 50%;
  }
  .card_message {
    bottom: 30%;
  }
  .position {
    margin-top: -50%;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1367px) {
}
@media only screen and (max-height: 768px) and (max-width: 1024px) {
}
</style>
